import * as React from 'react';
import {Autocomplete, CircularProgress, Divider, FormControlLabel, Radio, RadioGroup, TextField} from '@mui/material';
import {ThemeContext} from "../../App";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setAgentServices, setHeightBox, setInfoBox, setLengthBox, setPaymentTypeBox, setPriceBox, setSizeBox, setWeightBox, setWidthBox,} from "../../redux/singleOrder/infoBox/actions";
import {addCommas, handleBorderColor, removeNonNumeric} from "../../assets/js/main";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setCityIDSender, setCityNameSender, setLatSender, setLngSender, setStateIDSender, setStateNameSender} from "../../redux/singleOrder/sender/actions";
import {setCityIDReceiver, setCityNameReceiver, setLatReceiver, setLngReceiver, setStateIDReceiver, setStateNameReceiver} from "../../redux/singleOrder/receiver/actions";
import {Inventory2Outlined} from "@mui/icons-material";


export default function BoxInfo(props) {
  const {t} = useTranslation()
  const {fetchData} = HandleFetchData()
  const location = useLocation();

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [searchParams] = useSearchParams();
  const divarIncomId = searchParams.get('state')
  const theme = React.useContext(ThemeContext)
  const [_loading, set_Loading] = React.useState(false);
  const [showPaymentType, setShowPaymentType] = React.useState(false);
  const [listBoxSize, setListBoxSize] = React.useState([]);
  const [userInfo, setUserInfo] = React.useState(null)
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [textStateAndCitySender, setTextStateAndCitySender] = React.useState('')
  const [textStateAndCityReceiver, setTextStateAndCityReceiver] = React.useState('')


  React.useEffect(() => {
    handleGetBoxSize()
    handleGetStateAndCity()
    setUserInfo(JSON.parse(localStorage.getItem('info-user')))
    setTextStateAndCitySender(selector?.single_sender?.city_name ? selector?.single_sender?.state_name + '-' + selector?.single_sender?.city_name : '')
    setTextStateAndCityReceiver(selector?.single_receiver?.city_name ? selector?.single_receiver?.state_name + '-' + selector?.single_receiver?.city_name : '')

    dispatch(setPaymentTypeBox(process.env.REACT_APP_SITE === 'amnito' ? 'amnito' : 'online'))
  }, [])

  // متد دریافت لیست سایز جعبه ها
  const handleGetBoxSize = async () => {
    let fetch = await fetchData('', 'GET', '/StandardBoxSize', '', "text/html", '')
    setListBoxSize(fetch?.Data)
  }

  // متد دریافت لیست استان ها
  const handleGetStateAndCity = async (e) => {
    set_Loading(true)
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    const item = fetch?.data.find(e => e.id === '1-1')

    if(!e){
      if(!selector?.single_sender?.city_id){
        handleSetInfoStateAndCity(item, 'sender')
        setTextStateAndCitySender(item?.name)
      }
      if(!selector?.single_receiver?.city_id){
        handleSetInfoStateAndCity(item, 'receiver')
        setTextStateAndCityReceiver(item?.name)
      }
    }
    set_Loading(false)
  }

  const handleSetInfoStateAndCity = (value, flag) => {
    let name = e => value?.name?.split('-')[e]
    let id = e => value?.id?.split('-')[e]

    if (flag === 'sender') {
      dispatch(setCityNameSender(name(1) || ''))
      dispatch(setCityIDSender(id(1) || ''))
      dispatch(setStateNameSender(name(0) || ''))
      dispatch(setStateIDSender(id(0) || ''))
      dispatch(setLatSender(value?.lat || 35.7))
      dispatch(setLngSender(value?.lon || 51.4))
    } else {
      dispatch(setCityNameReceiver(name(1) || ''))
      dispatch(setCityIDReceiver(id(1) || ''))
      dispatch(setStateNameReceiver(name(0) || ''))
      dispatch(setStateIDReceiver(id(0) || ''))
      dispatch(setLatReceiver(value?.lat || 35.7))
      dispatch(setLngReceiver(value?.lon || 51.4))
    }
  }

  return (
     <>
       <div className="boxInfoPage">
         <div className="row">
           <div className={"col-12 bgInfo " + (theme.darkMode ? "bg_dark" : "bg_light")}>
             <div className="info">
               <h4 className="titleSection">{t("singleOrder.packageInfo.t1")}</h4>
               <div className="inputGroup">

                 <div className="row">
                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.sender.t19")}</label>
                     <Autocomplete
                        inputValue={textStateAndCitySender}
                        defaultValue={textStateAndCitySender}
                        noOptionsText={t("autoComplete.t1")}
                        ref={props.stateAndCityRefSender}
                        id="city-state-sender"
                        disablePortal
                        autoHighlight
                        loading={_loading}
                        onChange={(e, value, reason) => {
                          if (reason === 'clear') {
                            setTextStateAndCitySender('')
                            handleSetInfoStateAndCity(null, 'sender')
                          } else {
                            setTextStateAndCitySender(value?.name)
                            handleSetInfoStateAndCity(value, 'sender')
                          }
                        }}
                        options={listStateAndCity || []}
                        getOptionLabel={(option) => option?.name}
                        renderInput={(params) =>
                           <TextField {...params}
                                      hiddenLabel
                                      size="small"
                                      style={handleBorderColor(selector?.public?.validations?.state_and_city_validation_Sender)}
                                      placeholder={t("singleOrder.sender.t28")}
                                      onChange={(event) => {
                                        setTextStateAndCitySender(event?.target?.value)
                                        event?.target?.value?.length > 2 ? handleGetStateAndCity(event?.target?.value) : handleSetInfoStateAndCity(null, 'sender')
                                      }}
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                           <React.Fragment>
                                             {_loading ?
                                                <CircularProgress style={{margin: '0 5px'}} size={20}/>
                                                : null}
                                             {params.InputProps.endAdornment}
                                           </React.Fragment>
                                        ),
                                      }}
                           />}
                     />
                     {
                       selector?.public?.validations?.state_and_city_validation_Sender &&
                       <p className="error">{selector?.public?.validations?.state_and_city_validation_Sender}</p>
                     }
                   </div>

                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.receiver.t19")}</label>
                     <Autocomplete
                        inputValue={textStateAndCityReceiver}
                        defaultValue={textStateAndCityReceiver}
                        noOptionsText={t("autoComplete.t1")}
                        id="city-state-receiver"
                        ref={props.stateAndCityRefReceiver}
                        disablePortal
                        autoHighlight
                        loading={_loading}
                        onChange={(e, value, reason) => {
                          if (reason === 'clear') {
                            setTextStateAndCityReceiver('')
                            handleSetInfoStateAndCity(null, 'receiver')
                          } else {
                            setTextStateAndCityReceiver(value?.name)
                            handleSetInfoStateAndCity(value, 'receiver')
                          }
                        }}
                        options={listStateAndCity || []}
                        getOptionLabel={(option) => option?.name}
                        renderInput={(params) =>
                           <TextField {...params}
                                      hiddenLabel
                                      size="small"
                                      style={handleBorderColor(selector?.public?.validations?.state_and_city_validation_Receiver)}
                                      placeholder={t("singleOrder.sender.t28")}
                                      onChange={(event) => {
                                        setTextStateAndCityReceiver(event?.target?.value)
                                        event?.target?.value?.length > 2 ? handleGetStateAndCity(event?.target?.value) : handleSetInfoStateAndCity(null, 'receiver')
                                      }}
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                           <React.Fragment>
                                             {_loading ?
                                                <CircularProgress style={{margin: '0 5px'}} size={20}/>
                                                : null}
                                             {params.InputProps.endAdornment}
                                           </React.Fragment>
                                        ),
                                      }}
                           />}
                     />
                     {
                       selector?.public?.validations?.state_and_city_validation_Receiver &&
                       <p className="error">{selector?.public?.validations?.state_and_city_validation_Receiver}</p>
                     }
                   </div>

                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.packageInfo.t5")}</label>
                     <select aria-label="Default select example" ref={props.sizeRefSingle} id="size"
                             style={selector?.public?.validations?.size_validation_BoxInfo && {borderColor: '#FF3636'}}
                             onChange={(event) => {
                               dispatch(setSizeBox(
                                  event?.target?.value === 'max' ?
                                     event?.target?.value
                                     :
                                     listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Name
                               ))
                               dispatch(setLengthBox(
                                  listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Length
                               ))
                               dispatch(setWidthBox(
                                  listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Width
                               ))
                               dispatch(setHeightBox(
                                  listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Height
                               ))
                             }}>
                       <option value="" selected disabled>{
                         selector?.single_info_box?.size === "max" ? t("homeDesktop.s1.t4.tt22") : (selector?.single_info_box?.size || t("homeDesktop.s1.t4.tt10"))
                       }</option>
                       {
                         listBoxSize?.map((item, index) => <option
                            data-content={Inventory2Outlined}
                            key={item?.Id} value={item?.Id}>
                           {item?.Name}
                         </option>)
                       }

                       <option value="max">{t("homeDesktop.s1.t4.tt22")}</option>

                     </select>

                     {
                       selector?.single_info_box?.size === 'max' &&
                       <div className="row">
                         <div className="col-4">
                           <input type="number" min="1" name="length" id="length"
                                  onChange={(event) =>
                                     dispatch(setLengthBox(event?.target?.value))}
                                  placeholder={t("multiOrder.s2.t7")} value={selector?.single_info_box?.length || ""}/>
                         </div>
                         <div className="col-4">
                           <input type="number" min="1" name="width" id="width"
                                  onChange={(event) =>
                                     dispatch(setWidthBox(event?.target?.value))}
                                  placeholder={t("multiOrder.s2.t8")} value={selector?.single_info_box?.width || ""}/>
                         </div>
                         <div className="col-4">
                           <input type="number" min="1" name="height" id="height"
                                  onChange={(event) => dispatch(setHeightBox(event?.target?.value))}
                                  placeholder={t("multiOrder.s2.t9")} value={selector?.single_info_box?.height || ""}/>
                         </div>
                       </div>
                     }

                     {
                       selector?.public?.validations?.size_validation_BoxInfo &&
                       <p className="error">{selector?.public?.validations?.size_validation_BoxInfo}</p>
                     }
                   </div>

                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.packageInfo.t4")}</label>
                     <input type="text" autoComplete="on" min="0" ref={props.weightRefSingle}
                            style={handleBorderColor(selector?.public?.validations?.weight_validation_BoxInfo)}
                            inputMode='numeric' id="weight"
                            value={selector?.single_info_box?.weight}
                            onChange={e => dispatch(setWeightBox(addCommas(removeNonNumeric(e.target.value))))}/>

                     {
                       selector?.public?.validations?.weight_validation_BoxInfo &&
                       <p className="error">{selector?.public?.validations?.weight_validation_BoxInfo}</p>
                     }
                   </div>

                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.packageInfo.t3")}</label>
                     <input type="text" autoComplete="on"
                            style={handleBorderColor(selector?.public?.validations?.pricePost_validation_BoxInfo)}
                            ref={props.priceRefSingle} id="priceBox"
                            inputMode='numeric'
                            value={selector?.single_info_box?.price}
                            onChange={e => dispatch(setPriceBox(addCommas(removeNonNumeric(e.target.value))))}/>

                     {
                       selector?.public?.validations?.pricePost_validation_BoxInfo &&
                       <p className="error">{selector?.public?.validations?.pricePost_validation_BoxInfo}</p>
                     }
                   </div>

                   <div className="col-12 col-md-6">
                     <label className="required">{t("singleOrder.packageInfo.t2")}</label>
                     <input type="text" autoComplete="on" ref={props.infoRefSingle}
                            style={handleBorderColor(selector?.public?.validations?.infoPost_validation_BoxInfo)}
                            value={selector?.single_info_box?.info} id="infoBox"
                            onChange={e => dispatch(setInfoBox(e.target.value))}/>

                     {
                       selector?.public?.validations?.infoPost_validation_BoxInfo &&
                       <p className="error">{selector?.public?.validations?.infoPost_validation_BoxInfo}</p>
                     }
                   </div>

                 </div>

                 <Divider/>

                 <div className="paymentType">
                   <h4 className="titleSection">{t("singleOrder.packageInfo.t13")}</h4>
                   <RadioGroup
                      ref={props.paymentMethods}
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      row
                      id="paymentType"
                      value={selector?.single_info_box?.payment_type}
                      onChange={e => dispatch(setPaymentTypeBox(e.target.value))}
                   >
                     <div>

                       {process.env.REACT_APP_SITE === 'postex' &&
                       <FormControlLabel value="online" control={<Radio/>} label={
                         <>
                           {t("singleOrder.packageInfo.t14")}

                           {selector?.single_info_box?.payment_type === 'online' &&
                           <p className="helper-text">{t("singleOrder.packageInfo.t35")}</p>
                           }
                         </>
                       }/>
                       }

                       <FormControlLabel
                          value="amnito" control={<Radio/>} label={<>
                         {t("singleOrder.packageInfo.t16")}

                         {selector?.single_info_box?.payment_type === 'amnito' &&
                         <p className="helper-text">{t("singleOrder.packageInfo.t37")}</p>
                         }
                       </>}
                       />

                     </div>
                     {
                        process.env.REACT_APP_SITE === 'postex' &&
                        <div>
                          {/*{!divarIncomId && */}
                          <div className="request-store">
                            <p>{t("singleOrder.packageInfo.t42")}</p>
                            <Link to={{pathname: '/agencyRequest', search: location?.search}}>{t("singleOrder.packageInfo.t43")}</Link>
                            <button type="button" onClick={() => setShowPaymentType(!showPaymentType)}>{t("singleOrder.packageInfo.t44")}</button>
                          </div>
                          {/*}*/}

                          {
                             showPaymentType &&
                             <div className="d-flex">

                               {/*{!divarIncomId && */}
                               <FormControlLabel disabled value="cod" control={<Radio/>} label={
                                 <>
                                   {t("singleOrder.packageInfo.t15")}

                                   {selector?.single_info_box?.payment_type === 'cod' &&
                                      <p className="helper-text">{t("singleOrder.packageInfo.t34")}</p>
                                   }
                                 </>
                               }/>
                               {/*}*/}
                               {/*{!divarIncomId &&*/}
                               <FormControlLabel disabled value="free" control={<Radio/>} label={
                                 <>
                                   {t("singleOrder.packageInfo.t17")}

                                   {selector?.single_info_box?.payment_type === 'free' &&
                                      <p className="helper-text">{t("singleOrder.packageInfo.t36")}</p>
                                   }
                                 </>
                               }/>
                               {/*}*/}
                               {/*{!divarIncomId && */}
                               <FormControlLabel disabled value="pass" control={<Radio/>} label={
                                 <>
                                   {t("singleOrder.packageInfo.t18")}

                                   {selector?.single_info_box?.payment_type === 'pass' &&
                                      <p className="helper-text">{t("singleOrder.packageInfo.t38")}</p>
                                   }
                                 </>
                               }/>
                               {/*}*/}
                             </div>
                          }
                        </div>
                     }


                   </RadioGroup>
                   {
                      selector?.public?.validations?.payment_type_validation_BoxInfo &&
                      <p className="error">{selector?.public?.validations?.payment_type_validation_BoxInfo}</p>
                   }
                 </div>

                 {
                    userInfo && userInfo?.IsAgent &&
                    <div className="agentServices">
                      <h4 className="titleSection">{t("singleOrder.packageInfo.t39")}</h4>
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                          <label className="">{t("singleOrder.packageInfo.t40")}</label>
                          <input type="text" autoComplete="on"
                                 inputMode='numeric' id="agentServices"
                                 value={selector?.single_info_box?.agent_services}
                                 onChange={e => dispatch(setAgentServices(addCommas(removeNonNumeric(e.target.value))))}/>
                        </div>
                      </div>
                    </div>
                 }

               </div>

             </div>
           </div>
         </div>


       </div>
     </>
  )
}
